import React, { useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Dropdown from "react-dropdown";
import { useTranslation } from "react-i18next";

const sortOptions = [
    { value: 'Ascending price', label: 'Ascending price' },
    { value: 'Descending price', label: 'Descending price' },
    { value: 'Novelty', label: 'Novelty' },
    { value: 'Popularity', label: 'Popularity' },
    { value: 'Discount', label: 'Discount' },
    { value: 'Nearest time', label: 'Nearest time' },
    { value: 'Nearest locations', label: 'Nearest locations' },
];

interface MyCodesOrderCategoryProps {
    orderCategories: string[];
    selectedCategoryProps: string;
    handleSelectCategory: (category: string) => void
}

const MyCodesOrderCategory = (props: MyCodesOrderCategoryProps) => {
    const { t } = useTranslation();
    const { category } = useParams();
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState<string>(props.selectedCategoryProps);
    const [sortedBy, setSortedBy] = useState<string>("");

    const handleShowItemDetails = (categoryTmp: string) => () => {
        navigate(`/my-codes/${categoryTmp}`);
    }
    
    return (
        <div className="codesPageCategory__container">
            <div className="codesPageCategory__container_content">
                <div className="codesPageCategory__container_content_categories">
                    {
                        props.orderCategories.map((item: any, indx: number) => {
                            return (
                                <div
                                    key={indx}
                                    className={`codesPageCategory__container_content_categories_category ${selectedCategory === item ? "active" : ""}
                                    ${category === item ? 'active' : ''}
                                    `}
                                    onClick={() => {
                                        setSelectedCategory(item);
                                        props.handleSelectCategory(item);
                                        handleShowItemDetails(item.toLowerCase().replace(/\s/g, "-"));
                                        navigate(`/my-codes/${item.toLowerCase().replace(/\s/g, "-")}`);
                                    }}
                                >
                                    <span>
                                        {t(`categories.${item.toLowerCase()}`)}
                                    </span>
                                </div>
                            )
                        })
                    }
                </div>

                <div className="orderMainFoodCategory__container-sort-wrap dropdown">
                    <Dropdown
                        className={`orderMainFoodCategory__container-sort-dropdown
                        ${sortedBy !== "" ? 'active' : ''}
                        `}
                        arrowClosed={
                            <div className="orderMainFoodCategory__container-sort-icon">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-up.svg"}
                                    alt="sort up icon"
                                />
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-down.svg"}
                                    alt="sort down icon"
                                />
                            </div>
                        }
                        arrowOpen={
                            <div className="orderMainFoodCategory__container-sort-icon">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-up.svg"}
                                    alt="sort up icon"
                                />
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-down.svg"}
                                    alt="sort down icon"
                                />
                            </div>
                        }
                        options={sortOptions}
                        onChange={(e) => {
                            setSortedBy(e.value);
                        }}
                        value={
                            t(`categories.${(sortedBy === "" ? "sort" : sortedBy).toLowerCase()}`)
                        }
                    />
                </div>

            </div>
        </div>
    );
};

export default MyCodesOrderCategory;